<template>
  <div class="company_card">

    <a
      class="phone"
      :href="to_phone_number(company.phone_number)"
      @click="add_call_history()"
    >
      <img src="@/assets/phone.png">
    </a>

    <!-- クリックエリアを指定しないと電話した時に詳細画面に遷移してしまうので -->
    <div
      class="favorites"
      v-on:click.stop.prevent="add_or_remove_favorites()"
    >
      <img
        src="@/assets/star_on.png"
        v-if="is_already_favorite"
      >
      <img
        src="@/assets/star_off.png"
        v-else
      >
    </div>

    <div
      class="click_range"
      v-on:click="go_detail(company.company_name)"
    >

      <div class="header_space">
        <div class="company_name">
          {{ company.company_name }}
        </div>
      </div>

      <div class="area">
        <span
          v-for="(value, area) in company.area_list"
          :key="area"
        >
          <span v-if="value">
            {{area}}&nbsp;&nbsp;
          </span>
        </span>
      </div>

      <div class="price">
        <div class="key">
          <img
            class="icon"
            src="../assets/price.png"
          >
          料金</div>
        ：
        <span class="value">{{ company.basic_price }}</span>
      </div>

      <div class="business_hours">
        <div class="key">
          <img
            class="icon"
            src="../assets/time.png"
          >
          営業時間</div>
        ：
        <span class="value">{{ company.business_hours }}</span>
      </div>
    </div>

  </div>
</template>

<script>
import firebase from "firebase";
export default {
  data() {
    return {
      company: this.propCompany,
      firestore: firebase.firestore(),
      is_already_favorite: false,
      doc_id: "",
      is_running: false
    };
  },
  props: ["propCompany"],
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.is_already_favorite = await this.get_is_already_favorite();
    },
    add_call_history() {
      console.log("add_call_history 開始");
      if (this.is_running) return;
      this.is_running = true;
      let company = this.company;
      company.uuid = this.$store.state.user.uuid;
      const date = new Date();
      const unix_time = date.getTime();
      company.unix_time = unix_time;
      this.firestore
        .collection("call_history")
        .doc()
        .set(company)
        .then(function() {
          self.is_running = false;
          self.is_already_favorite = true;
          console.log("add_call_history　正常終了");
        })
        .catch(function(error) {
          self.is_running = false;
          console.error("add_call_history　error: ", error);
        });
    },
    to_phone_number(number) {
      console.log("number: " + number);
      return "tel:" + number;
    },
    go_detail(company_name) {
      this.$router.push({
        name: "companyDetail",
        query: { company_name: company_name }
      });
    },
    add_or_remove_favorites() {
      console.log("start add_or_remove_favorites");
      const self = this;
      if (this.is_running) return;
      this.is_running = true;
      if (this.is_already_favorite) {
        console.log("this.doc_id: " + this.doc_id);
        this.firestore
          .collection("favorites")
          .doc(this.doc_id)
          .delete()
          .then(function() {
            self.is_running = false;
            self.is_already_favorite = false;
            self.$emit("get_companiesList");
            console.log("お気に入り削除　完了");
          })
          .catch(function(error) {
            self.is_running = false;
            console.error("お気に入り削除　失敗: ", error);
          });
      } else {
        console.log("お気に入りしてない");
        let company = this.company;
        company.uuid = this.$store.state.user.uuid;
        const date = new Date();
        const unix_time = date.getTime();
        company.unix_time = unix_time;
        this.firestore
          .collection("favorites")
          .doc()
          .set(company)
          .then(function() {
            self.is_running = false;
            self.is_already_favorite = true;
            console.log("add_to_favorites　完了");
          })
          .catch(function(error) {
            self.is_running = false;
            console.error("add_to_favorites　完了: ", error);
          });
      }
    },
    async get_is_already_favorite() {
      this.firestore = firebase.firestore();
      return await this.firestore
        .collection("favorites")
        .where("uuid", "==", this.$store.state.user.uuid)
        .where("company_name", "==", this.company.company_name)
        .get()
        .then(docs => {
          console.log("[Favorites]get_is_already_favorite 完了");
          let is_exist = false;
          docs.forEach(doc => {
            this.doc_id = doc.id;
            is_exist = true;
          });
          return is_exist;
        })
        .catch(error => {
          console.log("[Favorites]Error getting documents: ", error);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.company_card {
  margin: 2vh 3vw 2vh 3vw;
  padding: 1vh 3vw 2vh 3vw;
  background-color: white;
  box-shadow: 0 0 10px rgb(220, 220, 220);
  position: relative;
  .click_range {
    width: 90%;
    height: 100%;
  }
  .company_name {
    font-weight: bold;
    width: 100%;
    text-align: left;
    font-size: 1.1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .phone {
    position: absolute;
    top: 3px;
    right: 35px;
    img {
      width: 28px;
      height: 28px;
    }
  }
  .favorites {
    position: absolute;
    top: 5px;
    right: 4px;
    img {
      width: 23px;
      height: 23px;
    }
  }
  .area {
    text-align: left;
    margin: 1vh 0 0 3vw;
    font-size: 0.8rem;
  }
  .business_hours {
    text-align: left;
    margin: 1vh 0 0 3vw;
  }
  .price {
    text-align: left;
    margin: 1vh 0 0 3vw;
  }
  img {
    width: 3vw;
    margin-right: 1vw;
  }
  .key {
    display: inline-block;
    width: 28%;
    font-size: 0.9rem;
    color: rgb(70, 70, 70);
  }
  .value {
    display: inline-block;
    width: 63%;
    vertical-align: top;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.9rem;
  }
}
</style>
